(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('wiki-root', {
                parent: 'entity',
                abstract: true,
                url: '/wiki',
                views: {
                    'filas@': {
                        template: ''
                    },
                    'navbar@': {
                        templateUrl: 'app/entities/wiki/wiki-navbar.html',
                        controller: 'WikiNavbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    specialClass: "white-bg"
                },
            })
            .state('wiki', {
                parent: 'wiki-root',
                url: '',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Visualização de Wiki'
                },
                views: {
                    'content@': {
                        controller: 'WikiRedirectController',
                        template: '<div class="text-center p-lg"><i class="fa fa-spinner fa-spin"></i></div>'
                    }
                }
            })
            .state('wiki-space', {
                parent: 'wiki-root',
                url: '/space/{spaceId}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Visualização de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Visualização de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-detail.html',
                        controller: 'WikiDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    space: ['$stateParams', 'WikiSpace', function ($stateParams, WikiSpace) {
                        return WikiSpace.get({id: $stateParams.spaceId}).$promise;
                    }],
                    entity: ['$stateParams', 'Wiki', function ($stateParams, Wiki) {
                        return Wiki.first({spaceId: $stateParams.spaceId}).$promise.then(function (data) {
                            return data && data.id ? data : null;
                        });
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('new-wiki', {
                parent: 'wiki-root',
                url: '/space/{spaceId}/new?superior',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Inclusão de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Inclusão de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-edit.html',
                        controller: 'WikiEditController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    superior: null
                },
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        var wiki = {
                            titulo: null,
                            conteudo: null,
                            id: null,
                            space: {id: parseInt($stateParams.spaceId, 10)}
                        };
                        if ($stateParams.superior) {
                            wiki.superior = {id: $stateParams.superior};
                        }
                        return wiki;
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('edit-wiki', {
                parent: 'wiki-root',
                url: '/space/{spaceId}/edit/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Edição de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Edição de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-edit.html',
                        controller: 'WikiEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Wiki', function ($stateParams, Wiki) {
                        return Wiki.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('detail-wiki', {
                parent: 'wiki-root',
                url: '/space/{spaceId}/page/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Visualização de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Visualização de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-detail.html',
                        controller: 'WikiDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    space: ['$stateParams', 'WikiSpace', function ($stateParams, WikiSpace) {
                        return WikiSpace.get({id: $stateParams.spaceId}).$promise;
                    }],
                    entity: ['$stateParams', 'Wiki', function ($stateParams, Wiki) {
                        return Wiki.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('wiki-spaces', {
                parent: 'wiki-root',
                url: '/spaces',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Gerenciar Espaços Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-space.html',
                        controller: 'WikiSpaceController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
